module.exports = __webpack_public_path__ + "static/img/info-txt.f9567600.jpg";